import { HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'owner' | 'admin' | 'agent' | 'viewer' | 'default'
  showTranslation?: boolean
}

const roleTranslations: Record<string, string> = {
  owner: 'Propietario',
  admin: 'Administrador',
  agent: 'Agente',
  viewer: 'Visualizador',
}

const roleLabels: Record<string, string> = {
  owner: 'OWNER',
  admin: 'ADMIN',
  agent: 'AGENT',
  viewer: 'VIEWER',
}

export function Badge({ className, variant = 'default', showTranslation = false, children, ...props }: BadgeProps) {
  const variantStyles = {
    owner: 'bg-purple-100 text-purple-800',
    admin: 'bg-blue-100 text-blue-800',
    agent: 'bg-green-100 text-green-800',
    viewer: 'bg-gray-100 text-gray-800',
    default: 'bg-gray-100 text-gray-800',
  }

  const displayText = showTranslation && variant !== 'default'
    ? `${roleLabels[variant]} - ${roleTranslations[variant]}`
    : roleLabels[variant] || children

  return (
    <span
      className={cn(
        'inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold',
        variantStyles[variant],
        className
      )}
      {...props}
    >
      {displayText}
    </span>
  )
}

// Export translations for use in other components
export { roleTranslations, roleLabels }

